import styled from "@emotion/styled";
import { LdTypo } from "@liquid/react";

const NotFoundOption = styled.div`
  padding: 7px 12px;
`;

const StyledTypo = styled(LdTypo)`
  padding-left: 36px;
`;

const StyledSearch = styled.div`
  padding: 7px 12px;
  border: 1px solid #e1e1ea;
`;

export { NotFoundOption, StyledTypo, StyledSearch };
